import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Track Orders',
  description:
    'Easily track your shipments with Ship&Play. Get real-time updates and notifications.',
  alternates: {
    canonical: 'https://www.shipplay.com/track-orders',
  },
}

export default metadata
